import Vue from "vue";
export const bus = new Vue();

export enum events {
  toggleSidebar = "toggleSidebar",
}
